import { v4 as uuid } from "uuid";
import TranslationAPI from "@/api/TranslationAPI";
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {TRANSLATION} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";
import moment from 'moment';


let initialState = {
    translations: null,
    init: true,
    key: "",
    reset() {
        let newObj = {...this};
        newObj.items = null;
        newObj.selectedDate = moment();
        newObj.selectedUsers = [];
        newObj.users = [];
        newObj.item = null;
        return newObj;
    }
};


const rejectEventHandler=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);
});
const pendingEventHandler=((state, action) => {
    state.apiState = TRANSLATION.API_PROCESSING;
})
let fullFilledEventHandler= ( (state, action) => {
    if(action.payload.data.translations) {
        state.translations = action.payload.data.translations;
    }
    
    //;
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
})



/*
let newDossier = localStorage.getItem("newDossier");
if(newDossier) {
    if(window.location.pathname == '/dossiers/new') {
    newDossier = JSON.parse(newDossier);
    initialState.selected = newDossier;
    initialState.apiState = DOSSIER.API_READY;
    initialState.view = DOSSIER.VIEW_NEW;
    } else {
        localStorage.removeItem("newDossier");
    }
}
*/
let task = null;
const TranslationReducer = createSlice({
  name: 'Translation',
  initialState,
  reducers: {

    // omit existing reducers here
  },
  extraReducers(builder) {
      
    task = loadTranslation;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));
 
    task = storeTranslation;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    
//    task = getTasks;
//    builder.addCase(task.fulfilled, ((state, action) => {return fullFilledEventHandler(state, action)})).addCase(task.rejected, ((state, action) => reject)).addCase(task.pending, ((state, action) => pending));
/*
    task = getTasks;
    builder.addCase(task.fulfilled, (state, action) => {
        fullFilledEventHandler(state, action);
        return;
    
    if(action.payload.data.item) {
        state.item = action.payload.data.item;
    }
    if(action.payload.data.selected) {
        state.selected = action.payload.data.selected;
    }
    if(action.payload.data.items) {
        state.items = action.payload.data.items;
    }
    state.view = COMCYCLE.CREATE_TASK;
    state.apiState = COMCYCLE.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;
    }).addCase(getTasks.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(getTasks.pending, (state, action) => {
        state.apiState = COMCYCLE.API_PROCESSING;
    });
*/    
  }
  })


export const loadTranslation = createAsyncThunk(TRANSLATION.LOAD_TRANSLATION, async (data:any, event) => {
    
    let response = null;
    try {
          response = await TranslationAPI.get(data);
          
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const storeTranslation = createAsyncThunk(TRANSLATION.API_STORE, async (data:any, event) => {
    
    let response = null;
    try {
          response = await TranslationAPI.store(data);
          
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


  
/*
export const dossierStore = createAsyncThunk(DOSSIER.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.index();
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)
*/

//export const { } = CommunicationCycleReducer.actions;
export default TranslationReducer.reducer